'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.defaultWrapChildren = defaultWrapChildren;
exports.createFader = createFader;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _inlineStylePrefixer = require('inline-style-prefixer');

var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-env browser */

var babelPluginFlowReactPropTypes_proptype_TransitionState = require('prop-types').oneOf(['in', 'out', 'entering', 'leaving']);

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_TransitionState', {
  value: babelPluginFlowReactPropTypes_proptype_TransitionState,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_DefaultProps = {
  animateHeight: require('prop-types').bool.isRequired,
  fadeInTransitionDuration: require('prop-types').number.isRequired,
  fadeInTransitionTimingFunction: require('prop-types').string.isRequired,
  fadeOutTransitionDuration: require('prop-types').number.isRequired,
  fadeOutTransitionTimingFunction: require('prop-types').string.isRequired,
  heightTransitionDuration: require('prop-types').number.isRequired,
  heightTransitionTimingFunction: require('prop-types').string.isRequired,
  prefixer: typeof _inlineStylePrefixer2.default === 'function' ? require('prop-types').instanceOf(_inlineStylePrefixer2.default).isRequired : require('prop-types').any.isRequired,
  style: require('prop-types').object.isRequired,
  measureHeight: require('prop-types').func.isRequired,
  shouldTransition: require('prop-types').func.isRequired
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_DefaultProps', {
  value: babelPluginFlowReactPropTypes_proptype_DefaultProps,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Props = {
  innerRef: require('prop-types').func,
  shouldTransition: require('prop-types').func.isRequired,
  children: require('prop-types').node,
  animateHeight: require('prop-types').bool.isRequired,
  fadeInTransitionDuration: require('prop-types').number.isRequired,
  fadeInTransitionTimingFunction: require('prop-types').string.isRequired,
  fadeOutTransitionDuration: require('prop-types').number.isRequired,
  fadeOutTransitionTimingFunction: require('prop-types').string.isRequired,
  heightTransitionDuration: require('prop-types').number.isRequired,
  heightTransitionTimingFunction: require('prop-types').string.isRequired,
  prefixer: typeof _inlineStylePrefixer2.default === 'function' ? require('prop-types').instanceOf(_inlineStylePrefixer2.default).isRequired : require('prop-types').any.isRequired,
  style: require('prop-types').object.isRequired,
  fillParent: require('prop-types').bool,
  className: require('prop-types').string,
  measureHeight: require('prop-types').func.isRequired
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Props', {
  value: babelPluginFlowReactPropTypes_proptype_Props,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_State = {
  children: function children(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  height: require('prop-types').number,
  wrappedChildren: require('prop-types').node.isRequired,
  transitionState: require('prop-types').oneOf(['in', 'out', 'entering', 'leaving']).isRequired,
  transitioningHeight: require('prop-types').bool.isRequired
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_State', {
  value: babelPluginFlowReactPropTypes_proptype_State,
  configurable: true
});
var babelPluginFlowReactPropTypes_proptype_Options = {
  wrapChildren: require('prop-types').func
};
if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Options', {
  value: babelPluginFlowReactPropTypes_proptype_Options,
  configurable: true
});
function defaultWrapChildren(children, transitionState) {
  var _this = this;

  var _props = this.props,
      prefixer = _props.prefixer,
      fillParent = _props.fillParent;

  var style = { transitionProperty: 'opacity' };
  if (fillParent) {
    style.position = 'absolute';
    style.top = 0;
    style.left = 0;
    style.right = 0;
    style.bottom = 0;
    style.overflow = 'auto';
  }
  switch (transitionState) {
    case 'out':
    case 'entering':
      style.opacity = transitionState === 'entering' ? 1 : 0;
      style.transitionDuration = this.props.fadeInTransitionTimingFunction + 'ms';
      style.transitionTimingFunction = this.props.fadeInTransitionTimingFunction;
      break;
    case 'in':
    case 'leaving':
      style.opacity = transitionState === 'in' ? 1 : 0;
      style.transitionDuration = this.props.fadeOutTransitionDuration + 'ms';
      style.transitionTimingFunction = this.props.fadeOutTransitionTimingFunction;
      break;
  }
  return React.createElement(
    'div',
    {
      'data-transition-state': transitionState,
      style: prefixer.prefix(style)
    },
    children && React.cloneElement(children, { ref: function ref(c) {
        return _this.wrappedChildrenRef = c;
      } })
  );
}

defaultWrapChildren.contextTypes = babelPluginFlowReactPropTypes_proptype_TransitionState;
function createFader() {
  var _class, _temp2;

  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return _temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(Fader, _React$Component);

    function Fader() {
      var _ref;

      var _temp, _this2, _ret;

      (0, _classCallCheck3.default)(this, Fader);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = Fader.__proto__ || (0, _getPrototypeOf2.default)(Fader)).call.apply(_ref, [this].concat(args))), _this2), _this2.measureHeight = function (node) {
        return node ? _this2.props.measureHeight(node) : null;
      }, _this2.timeouts = {}, _this2.wrapChildren = (options.wrapChildren || defaultWrapChildren).bind(_this2), _this2.state = {
        children: _this2.props.children,
        height: undefined,
        wrappedChildren: _this2.wrapChildren(_this2.props.children, 'in'),
        transitionState: 'in',
        transitioningHeight: false
      }, _this2.onTransitionEnd = function (e) {
        var shouldTransition = _this2.props.shouldTransition;
        var transitionState = _this2.state.transitionState;

        if (transitionState === 'leaving') {
          _this2.setState({
            transitionState: 'out',
            wrappedChildren: _this2.wrapChildren(_this2.props.children, 'out')
          });
        } else if (transitionState === 'entering') {
          if (shouldTransition(_this2.state.children, _this2.props.children)) {
            _this2.setState({
              transitionState: 'leaving',
              wrappedChildren: _this2.wrapChildren(_this2.state.children, 'leaving')
            });
            _this2.setTimeout('fadeOut', _this2.onTransitionEnd, _this2.props.fadeOutTransitionDuration);
          } else {
            _this2.setState({
              transitionState: 'in',
              height: undefined,
              wrappedChildren: _this2.wrapChildren(_this2.props.children, 'in')
            });
          }
        }
      }, _this2.onHeightTransitionEnd = function (e) {
        _this2.setState({ transitioningHeight: false });
      }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
    }

    (0, _createClass3.default)(Fader, [{
      key: 'setTimeout',
      value: function (_setTimeout) {
        function setTimeout(_x2, _x3, _x4) {
          return _setTimeout.apply(this, arguments);
        }

        setTimeout.toString = function () {
          return _setTimeout.toString();
        };

        return setTimeout;
      }(function (name, callback, delay) {
        if (this.timeouts[name]) clearTimeout(this.timeouts[name]);
        this.timeouts[name] = setTimeout(callback, delay);
      })
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        var _state = this.state,
            transitionState = _state.transitionState,
            height = _state.height,
            transitioningHeight = _state.transitioningHeight;
        var _props2 = this.props,
            animateHeight = _props2.animateHeight,
            fillParent = _props2.fillParent;

        var shouldTransition = this.props.shouldTransition(this.state.children, this.props.children);

        if (transitionState === 'in' && shouldTransition) {
          var newState = {};
          newState.children = this.props.children;
          newState.transitionState = 'leaving';
          newState.wrappedChildren = this.wrapChildren(this.state.children, 'leaving');
          this.setTimeout('fadeOut', this.onTransitionEnd, this.props.fadeOutTransitionDuration);
          if (animateHeight && !fillParent) {
            if (height === undefined) newState.height = this.measureHeight(this.wrappedChildrenRef);
          }
          this.setState(newState);
        } else if (transitionState === 'leaving' && animateHeight && !fillParent) {
          if (!transitioningHeight) this.setState({ transitioningHeight: true });
        } else if (transitionState === 'out') {
          var _newState = {};
          if (shouldTransition) {
            _newState.children = this.props.children;
            _newState.wrappedChildren = this.wrapChildren(this.props.children, 'out');
          } else {
            _newState.transitionState = 'entering';
            _newState.children = this.props.children;
            _newState.wrappedChildren = this.wrapChildren(this.props.children, 'entering');
            this.setTimeout('fadeIn', this.onTransitionEnd, this.props.fadeInTransitionDuration);
            if (animateHeight && !fillParent) {
              _newState.height = this.measureHeight(this.wrappedChildrenRef);
              this.setTimeout('height', this.onHeightTransitionEnd, this.props.heightTransitionDuration);
            }
          }
          this.setState(_newState);
        } else if (!shouldTransition && this.state.children !== this.props.children) {
          var _newState2 = {};
          _newState2.children = this.props.children;
          _newState2.wrappedChildren = this.wrapChildren(this.props.children, transitionState);
          this.setState(_newState2);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        for (var _name in this.timeouts) {
          clearTimeout(this.timeouts[_name]);
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _state2 = this.state,
            height = _state2.height,
            transitioningHeight = _state2.transitioningHeight,
            wrappedChildren = _state2.wrappedChildren;
        var _props3 = this.props,
            className = _props3.className,
            prefixer = _props3.prefixer,
            fillParent = _props3.fillParent,
            innerRef = _props3.innerRef;

        var style = (0, _extends3.default)({}, this.props.style);
        if (height != null) style.height = height;
        if (transitioningHeight) {
          style.overflow = 'hidden';
          style.transitionProperty = 'height';
          style.transitionDuration = this.props.heightTransitionDuration + 'ms';
          style.transitionTimingFunction = this.props.heightTransitionTimingFunction;
        }
        if (fillParent) {
          style.position = 'absolute';
          style.top = 0;
          style.left = 0;
          style.right = 0;
          style.bottom = 0;
        }
        return React.createElement(
          'div',
          { className: className, style: prefixer.prefix(style), ref: innerRef },
          wrappedChildren
        );
      }
    }]);
    return Fader;
  }(React.Component), _class.defaultProps = {
    animateHeight: true,
    fadeInTransitionDuration: 200,
    fadeInTransitionTimingFunction: 'linear',
    fadeOutTransitionDuration: 200,
    fadeOutTransitionTimingFunction: 'linear',
    heightTransitionDuration: 200,
    heightTransitionTimingFunction: 'ease',
    prefixer: new _inlineStylePrefixer2.default(),
    style: {},
    measureHeight: function measureHeight(node) {
      return node.offsetHeight;
    },
    shouldTransition: function shouldTransition(oldChildren, newChildren) {
      if (oldChildren === newChildren) return false;
      if (React.isValidElement(oldChildren) && React.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
        return false;
      }
      return true;
    }
  }, _temp2;
}

exports.default = createFader();


// WEBPACK FOOTER //
// ./node_modules/react-fader/lib/index.js